<wdx-form-field
    [locked]="formElement.isLocked"
    [label]="(formElement.label | translateTokenisedString) || ''"
    [guidanceText]="(formElement.guidanceText | translateTokenisedString) || ''"
    [isSensitive]="formElement.isSensitive ?? undefined"
    [isRequired]="formElement.isRequired ?? undefined"
    [labelForId]="inputId"
    [validationErrorMessage]="
        formControl?.touched
            ? (formControl?.errors | validationErrorMessage)
            : ''
    "
    [warningMessage]="warningText"
>
    <div class="input-group">
        <input
            wdxInputText
            currencyMask
            [options]="decimalMaskNumberConfigOverride"
            [attr.id]="inputId"
            [attr.data-cy]="'input-' + formElement.name"
            [attr.placeholder]="formElement.placeholder"
            [attr.required]="formElement.isRequired"
            [wdxUtilsDisabled]="!!isDisabled"
            [ngModel]="timeValue"
            (ngModelChange)="timeValueChange($event)"
        />
        <ng-select
            [(ngModel)]="timeUnit"
            (ngModelChange)="timeUnitChange()"
            [readonly]="timeUnits.length === 1"
            [clearable]="false"
            [items]="timeUnits"
        />
    </div>
</wdx-form-field>
